import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from 'react';
import Tab from 'react-bootstrap/Tab';
import { TabGroupNav } from './components/TabGroupNav';
import { TabGroupLayout } from './components/TabGroupLayout';
export const TabContainer = ({ variant, tabs, defaultKey }) => {
    const [key, setKey] = useState(tabs[0] ? tabs[0].eventKey : '');
    const tabnav = useMemo(() => tabs === null || tabs === void 0 ? void 0 : tabs.map((t) => (_jsx(TabGroupNav, { eventKey: t.eventKey, label: t.label, variant: variant, validation: t.validation || 'none', disabled: t.disabled }, t.eventKey + t.label))), [tabs, variant]);
    useEffect(() => {
        if (!!defaultKey)
            setKey(defaultKey);
    }, [defaultKey]);
    if (!tabs)
        return null;
    return (_jsx("div", Object.assign({ className: `tabgroup` }, { children: _jsx(Tab.Container, Object.assign({ id: 'tab1', activeKey: key, onSelect: (k) => setKey(k) }, { children: _jsx(TabGroupLayout, { variant: variant, nav: tabnav, tabs: tabs }) })) })));
};
